import HeartFilled from '../src/HeartFilled';
export default HeartFilled;
